const APP_SOCKET_IO_URL: string = window?.['_env_']?.VUE_APP_SOCKET_IO_URL;
const APP_API_URL: string = window?.['_env_']?.VUE_APP_API_URL;

export { APP_API_URL, APP_SOCKET_IO_URL };
